import sum from 'ramda/es/sum'
import curry from 'ramda/es/curry'

export const avg = (nums: number[]) => sum(nums) / nums.length

export const percent = curry(
  (total: number, val: number) => (val / total) * 100,
)
